module.exports = __webpack_public_path__ + "static/media/bed-moving-Icon-Rev-Ora.dcf4b10b.svg";